import { withSearch } from '@elastic/react-search-ui';
import DropDownFacetFilters from '../../../components/filter/DropDownFacetFilter';

const EducationalImagesDistrictFilter = ({
  facets,
  filters,
  setFilter,
  removeFilter,
}) => {
  return (
    <DropDownFacetFilters
      facets={facets}
      fieldId="district"
      filters={filters}
      formHint="Includes county councils, unitary authorities, London boroughs and all districts"
      id="district"
      label="Local authority"
      removeFilter={removeFilter}
      setFilter={setFilter}
    />
  );
};

export default withSearch(({ facets, filters, setFilter, removeFilter }) => ({
  facets,
  filters,
  setFilter,
  removeFilter,
}))(EducationalImagesDistrictFilter);
